import React from 'react';
import {Alert, Card, Col, Progress, Row, Statistic} from 'antd';

const TrusworthinessStats = ({commandes, seuil = 0.8}) => {
    if (!commandes || commandes.length === 0) {
        return <Card>Aucune commande trouvée</Card>;
    }

    // Calcul des statistiques
    const totalCommandes = commandes.length;
    const commandesPayees = commandes.filter(
        commande =>
            commande?.statutCommande === 'REGLE' || commande?.statutCommande === 'DELIVRE' || commande?.statutCommande === 'RECEPTIONNE'  &&
            commande.reglement
    );
    const nombreCommandesPayees = commandesPayees.length;
    const scoreConfiance = nombreCommandesPayees / totalCommandes;
    const pourcentageConfiance = Math.round(scoreConfiance * 100);

    return (
        <Card title="Statistiques de Confiance" style={{maxWidth: 600, margin: 'auto'}}>
            <Row gutter={16}>
                <Col span={8}>
                    <Statistic title="Total des Commandes" value={totalCommandes}/>
                </Col>
                <Col span={8}>
                    <Statistic title="Commandes Payées" value={nombreCommandesPayees}/>
                </Col>
                <Col span={8}>
                    <Statistic title="Score de Confiance" value={`${pourcentageConfiance}%`}/>
                </Col>
            </Row>
            <Row style={{marginTop: 24}}>
                <Col span={24}>
                    <Progress
                        percent={pourcentageConfiance}
                        status={scoreConfiance >= seuil ? 'success' : 'exception'}
                    />
                </Col>
            </Row>
            <Row style={{marginTop: 24}}>
                <Col span={24} style={{textAlign: 'center'}}>
                    <h3>
                      
                        {scoreConfiance >= seuil
                            ? (
                                <Alert
                                    message={"Cette compagnie est digne de confiance pour le règlement."}
                                    type={"success"}
                                />

                            )
                            :
                            (
                                <Alert message={"Cette compagnie n'est pas considérée comme fiable pour le règlement."}
                                       type={"warning"}/>

                            )
                        }
                    </h3>
                </Col>
            </Row>
        </Card>
    );
};

export default TrusworthinessStats;
